import { render, staticRenderFns } from "./EmailRichEditor.vue?vue&type=template&id=6da459f6&scoped=true&"
import script from "./EmailRichEditor.vue?vue&type=script&lang=ts&"
export * from "./EmailRichEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EmailRichEditor.vue?vue&type=style&index=0&id=6da459f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da459f6",
  null
  
)

export default component.exports